<template>
  <div class="card">
    <div class="card-header pb-0 mb-2">
      <h6>Payments table</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :pagination-options="{
            enabled: true,
            mode: 'records',
          }"
          :search-options="{ enabled: true }"
          :line-numbers="true"
          :isLoading="isLoading"
        >
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Datatable-Payments",
  props: {
    //   users: {
    //     type: Array,
    //     default: () => [],
    //   },
    rows: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
